export const formatVehicleNo = (vehicleNo) => {
    if (!vehicleNo) {
        return { formatted: "", error: "" };
    }
    vehicleNo = vehicleNo.replace(/ /g, "").toUpperCase();   
    let errorMessage = '';
    
    if (vehicleNo.length >= 1 && !/^[A-Z]/.test(vehicleNo)) {
        errorMessage = 'The first character must be an alphabet.';
    }
    if (vehicleNo.length >= 2 && !/^[A-Z]{2}/.test(vehicleNo)) {
        errorMessage = 'The second character must be an alphabet.';
    }
    if (vehicleNo.length >= 3 && !/^[A-Z]{2}\d/.test(vehicleNo)) {
        errorMessage = 'The third character must be a digit.';
    }
    
    if (errorMessage) {
        return { formatted: vehicleNo, error: errorMessage };
    }
    
    // More flexible pattern matching
    const pattern = /^([A-Z]{2})(\d{0,2})([A-Z]{0,3})?(\d{0,4})?$/;
    const match = vehicleNo.match(pattern);
    
    if (match) {
        const [, part1, part2, part3, part4] = match;
        let formatted = part1;
        
        if (part2) {
            formatted += ` ${part2}`;
        }
        if (part3) {
            formatted += ` ${part3}`;
        }
        if (part4) {
            formatted += ` ${part4}`;
        }
        
        return { formatted, error: '' };
    } else {
        return { formatted: vehicleNo, error: '' };
    }
};